import './App.css';
import {useState} from 'react';

function App() {
  const [count,setCount]= useState(0);
  return (
    <div className="App">
      <header className="App-header">
        <h1>Count - {count} </h1>
        <button onClick={()=> {setCount(count+1)} }>Increase Count </button>
        <button onClick={()=> {
           if (count > 0) {
            setCount(count - 1);
          }
      
        } }>Decrease Count </button>

      </header>
    </div>
  );
}

export default App;
